import styled from 'styled-components/macro'

import { ImageContainer, Img } from 'components/parallax/styled'
import { mq } from 'styles/mq'

export const PhoneRightContainer = styled(ImageContainer)`
  ${mq.parallaxOn} {
    padding-inline: var(--spacing-sm);
    margin-bottom: -20px;
  }
`

export const PhoneLeftContainer = styled(PhoneRightContainer)`
  ${mq.parallaxOff} {
    margin-block: var(--spacing-lg);
  }
`

export const PhoneImg = styled(Img)`
  margin: 0 auto;

  ${mq.parallaxOn} {
    max-width: 13rem;
  }

  ${mq.large} {
    max-width: 16rem;
  }
`
